import { render } from "./become-a-leader.vue?vue&type=template&id=ad0a6810"
import script from "./become-a-leader.vue?vue&type=script&lang=js"
export * from "./become-a-leader.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__